import React from "react";
import UseGetDashBoardData from "../../../../../Components/Hooks/useDashboardData";

function Returns() {
  const { data, loading } = UseGetDashBoardData(`/dashboard/returnDetails`);

  return (
    <div className="bg-white p-5 rounded-2xl border border-gray-100 shadow-[0_4px_25px_rgba(0,0,0,0.04)] transition-all duration-300">
      <div className="flex justify-between items-center pb-3 border-b border-gray-100 mb-3">
        <div className="flex items-center space-x-2">
          <div className="w-7 h-7 rounded-lg bg-rose-50 flex items-center justify-center text-rose-600">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M16 15v-1a4 4 0 00-4-4H4m0 0l4-4m-4 4l4 4" />
            </svg>
          </div>
          <h3 className="text-sm font-semibold text-gray-800">Inventory Return Log</h3>
        </div>

        <span className="text-xs font-bold px-2.5 py-0.5 rounded-full bg-rose-50 text-rose-700 border border-rose-200/50">
          Returns Feed
        </span>
      </div>

      {loading ? (
        <div className="h-48 flex items-center justify-center animate-pulse">
          <div className="h-32 bg-gray-100 rounded-xl w-full"></div>
        </div>
      ) : (
        <div className="max-h-56 overflow-y-auto pr-1">
          <table className="w-full text-xs">
            <thead className="sticky top-0 bg-gray-50 text-gray-500 font-semibold border-b border-gray-200">
              <tr>
                <th className="py-2 px-2 text-left">Company</th>
                <th className="py-2 px-2 text-left">Return Type</th>
                <th className="py-2 px-2 text-right">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50/70 transition-colors">
                    <td className="py-2.5 px-2 font-semibold text-gray-900 truncate max-w-[140px]">{item?.companyName || "N/A"}</td>
                    <td className="py-2.5 px-2 text-gray-600 truncate max-w-[120px]">{item?.type || "N/A"}</td>
                    <td className="py-2.5 px-2 text-right">
                      <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-rose-50 text-rose-700 border border-rose-200/50">
                        {item?.status || "Processed"}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={3} className="py-6 text-center text-gray-400">
                    No return records available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default Returns;